import service from '@/store/services/functions_edit-service';

const state = {
    functionsList: {},
    functionsListDescription: {},
    updatedFunction: {},
    banFunctionForChosenUser: {}
};

const mutations = {
    SET_FUNCTIONS_LIST: (state, functionsList) => {
        state.functionsList = functionsList;
    },
    SET_FUNCTIONS_LIST_DESCRIPTION: (state, functionsListDescription) => {
        state.functionsListDescription = functionsListDescription;
    },
    SET_UPDATED_FUNCTION: (state, updatedFunction) => {
        state.updatedFunction = updatedFunction;
    },
    SET_FUNCTIONS_BAN_FOR_USER: (state, banFunctionForChosenUser) => {
        state.banFunctionForChosenUser = banFunctionForChosenUser;
    },

};

const actions = {
    functionsList({commit}) {
        return service.getFunctionsList()
            .then(({functionsList}) => {
                commit('SET_FUNCTIONS_LIST', functionsList);
            });
    },
    functionsListDescription({commit}, params) {
        return service.getFunctionsListDescription(params)
            .then(({functionsListDescription}) => {
                commit('SET_FUNCTIONS_LIST_DESCRIPTION', functionsListDescription);
            });
    },
    banFunctionForChosenUser({commit}, params) {
        return service.banFunctionForChosenUser(params)
            .then(({banFunctionForChosenUser}) => {
                commit('SET_FUNCTIONS_BAN_FOR_USER', banFunctionForChosenUser);
            });
    },
    updatedFunction({commit, dispatch}, params) {
        return service.updateFunction(params)
            .then(({updatedFunction}) => {
                commit('SET_UPDATED_FUNCTION', updatedFunction);
            });
    },
    changeFunctionsList({commit}, params) {
        return commit('SET_FUNCTIONS_LIST', params);
    }

};

const getters = {
    functionsList: state => state.functionsList,
    functionsListDescription: state => state.functionsListDescription,
    updatedFunction: state => state.updatedFunction,
    banFunctionForChosenUser: state => getterKey => state.updatedFunction,
};

const functionsEdit = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default functionsEdit;